import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class ItemView extends AbstractView {

    constructor(target) {
        super(target);
        this._target.mouseChildren = false;
        this._target.gotoAndStop(0);
        this._yOrig = this._target.y;
        this._scale = this._target.getChildAt(0).scaleX;
        this.content = null;
    }

    get target() {
        return this._target;
    }

    set content(skin) {
        this._target.removeAllChildren();
        this._content = skin;
        if (skin) {
            this._target.addChild(skin);
            skin._scaleX = skin._scaleY = this._scale;
        }
    }

    get content() {
        return this._content;
    }

    hop() {
        createjs.Tween.get(this._target, { loop: 5, bounce: true })
            .to({ y: this._yOrig - 50 }, 100, createjs.Ease.linear);
    }

    disappear() {
        const s = 1.2;
        createjs.Tween.get(this._target)
            .to({ y: this._yOrig - 50, scaleX: s, scaleY: s, alpha: 0 }, 300, createjs.Ease.linear);
    }
}
